import { EmotionStatus, EmotionIcon } from './types';

/**
 * Determines emotion status based on percentage
 * @param percentage - Emotion percentage (0-100)
 * @returns Emotion status for styling
 */
export const getEmotionStatus = (percentage: number): EmotionStatus => {
    if (percentage >= 70) return 'success';      // Happy: 70-100%
    if (percentage >= 40) return 'normal';       // Neutral: 40-69%
    return 'poor';                                // Sad: 0-39%
};

/**
 * Gets the appropriate emotion icon based on percentage
 * @param percentage - Emotion percentage (0-100)
 * @returns Icon type to display
 */
export const getEmotionIcon = (percentage: number): EmotionIcon => {
    if (percentage >= 70) return 'smile';        // Happy face
    if (percentage >= 40) return 'meh';          // Neutral face
    return 'frown';                               // Sad face
};
